import React from "react";
import UserTable from "../user-table";
import { AccountCards } from "../../../components/cards/account-card";



const Buyer = ({ data, statistics, selectedStatus, handleStatusChange, handleDateRangeChange, loading, handleResetFilters }: any) => {
  return (
    <div>
      <AccountCards statistics={statistics}  />
      <UserTable data={data} selectedStatus={selectedStatus} handleStatusChange={handleStatusChange} handleDateRangeChange={handleDateRangeChange} handleResetFilters={handleResetFilters} loading={loading} />
    </div>
  );
};

export default Buyer;
